class LasiriusAvizeSelector extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    this.steps = [...this.querySelectorAll('[data-avize-step]')];
    this.radios = [...this.querySelectorAll('input[type="radio"]')];
    this.message = this.querySelector('[data-avize-message]');
    this.submitButton = this.form?.querySelector('[data-avize-submit]');
    this.inventoryDisabled = this.submitButton?.dataset.inventoryDisabled === 'true';

    if (this.steps.length > 1) {
      this.steps.slice(1).forEach((step) => step.removeAttribute('open'));
    }

    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.handleChange(radio));
    });
    this.form?.addEventListener('submit', (event) => this.handleSubmit(event));
    this.update();
  }

  handleChange(radio) {
    const step = radio.closest('[data-avize-step]');
    const nextStep = step?.nextElementSibling;
    if (nextStep?.matches('[data-avize-step]')) {
      nextStep.setAttribute('open', '');
    }
    this.update();
  }

  handleSubmit(event) {
    const firstMissing = this.steps.find((step) => !step.querySelector('input:checked'));
    if (!firstMissing) return;

    event.preventDefault();
    firstMissing.setAttribute('open', '');
    firstMissing.querySelector('input')?.focus();
    if (this.message) {
      this.message.textContent = 'Lütfen her gövde için bir renk seçin.';
    }
  }

  update() {
    let completeCount = 0;
    this.steps.forEach((step) => {
      const checked = step.querySelector('input:checked');
      const index = step.dataset.avizeStep;
      const status = step.querySelector('[data-avize-step-status]');
      const summary = this.querySelector(`[data-avize-summary="${index}"]`);
      step.toggleAttribute('data-complete', Boolean(checked));

      if (checked) completeCount += 1;
      if (status) status.textContent = checked ? checked.value : 'Renk seçilmedi';
      if (summary) summary.textContent = checked ? checked.value : 'Seçilmedi';
    });

    const isComplete = completeCount === this.steps.length;
    if (this.submitButton && !this.hasAttribute('data-demo')) {
      this.submitButton.disabled = this.inventoryDisabled || !isComplete;
      this.submitButton.setAttribute('aria-disabled', String(this.inventoryDisabled || !isComplete));
    }
    if (this.message) {
      this.message.textContent = isComplete
        ? 'Seçimleriniz hazır.'
        : `Sepete eklemek için ${this.steps.length - completeCount} gövde rengi daha seçin.`;
    }
  }
}

if (!customElements.get('avize-selector')) {
  customElements.define('avize-selector', LasiriusAvizeSelector);
}
